// src/config.ts
// Central config for environment variables and constants

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3001';